import { ReactNode } from 'react';

import { useStoreSelection } from './hooks';
import { StoresContext } from './stores.context';
import { StoresContextType } from './stores.types';

import { useStores } from '~/api/easy-estimator-api/stores-api/useStores';
import { useRetailerSettings } from '~/core/hooks/useRetailerSettings';
import { useAppSelector } from '~/redux/hooks';
import { selectSelectedStore } from '~/redux/slices/store';

export const StoresContextProvider = ({
  children,
}: {
  children?: ReactNode;
}): JSX.Element => {
  const { stores, isFetchingStores, zipCodeLocation } = useStores();
  const { retailerSettings } = useRetailerSettings();
  const selectedStore = useAppSelector(selectSelectedStore);

  const {
    handleStoreSelection,
    confirmStoreChange,
    cancelStoreChange,
    isChangeStoreConfirmationModalOpen,
    storeCandidate,
    lastReconciledStoreIdRef,
  } = useStoreSelection();

  const contextValue: StoresContextType = {
    getters: {
      storeCandidate,
      isChangeStoreConfirmationModalOpen,
      isFetchingStores,
      isOnlineRetailer: retailerSettings?.isOnlineRetailer ?? true,
      stores,
      googleMapsApiKey: retailerSettings?.googleMapApiKey,
      googleMapsMapId: retailerSettings?.googleMapApiMapId,
      zipCodeLocation,
      selectedStore,
      lastReconciledStoreIdRef,
    },
    handlers: {
      cancelStoreChange,
      confirmStoreChange,
      handleStoreSelection,
    },
  };

  return (
    <StoresContext.Provider value={contextValue}>
      {children}
    </StoresContext.Provider>
  );
};
